import { ApiUrls } from '../ApiUrls';
import { httpService } from '../..';
import { IContact, IDeactivateContactRequest } from './contactInterfaces';
import { IEntityWithMessages } from '../../services/HttpService';

export async function activateContact(request: IDeactivateContactRequest): Promise<void> {
  try {
    await httpService.post(ApiUrls.activateContact(request));
    //return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function addContact(contact: IContact): Promise<IEntityWithMessages<IContact>> {
  try {
    const response = await httpService.post(ApiUrls.contactsByBusinessEntity(contact.businessEntityId), contact);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function deactivateContact(request: IDeactivateContactRequest): Promise<void> {
  try {
    await httpService.post(ApiUrls.deactivateContact(request));
    //return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchContacts(businessEntityId: number, lastFetched?: Date): Promise<IContact[]> {
  try {
    const response = await httpService.get(ApiUrls.contactsByBusinessEntity(businessEntityId));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchContactsById(contactIds: number[]): Promise<IContact[]> {
  try {
    const response = await httpService.get(ApiUrls.contactsById(contactIds));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateContact(contact: IContact): Promise<IEntityWithMessages<IContact>> {
  try {
    const response = await httpService.put(ApiUrls.contactsByBusinessEntity(contact.businessEntityId), contact);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
